exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-articles-markdown-remark-frontmatter-slug-tsx": () => import("./../../../src/pages/articles/{markdownRemark.frontmatter__slug}.tsx" /* webpackChunkName: "component---src-pages-articles-markdown-remark-frontmatter-slug-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

